module.exports = __webpack_public_path__ + "static/oxford-d703e89e2b38730b69894dfbd9d868d5.png";